import React, { useState } from "react";
import { Layout, Drawer, Button, Grid } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";

const { Header: AntHeader } = Layout;
const { useBreakpoint } = Grid;

const logoImage = "images/logo.png";

const Header: React.FC = () => {
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const screens = useBreakpoint();
  const location = useLocation();

  const navigationItems = [
    { key: "apply", label: "Apply For Incentive", path: "/" },
    { key: "about", label: "About the Program", path: "/about" },
    { key: "status", label: "Check Application Status", path: "/status" },
    { key: "shops", label: "Participating Shops", path: "/shops" },
    { key: "faqs", label: "FAQs", path: "/faqs" },
    { key: "contact", label: "Contact Us", path: "/contact" },
  ];

  const showMobileMenu = () => {
    setMobileMenuVisible(true);
  };

  const hideMobileMenu = () => {
    setMobileMenuVisible(false);
  };

  const renderNavigationItems = () => {
    return navigationItems.map((item) => (
      <div
        key={item.key}
        className={`nav-item ${location.pathname === item.path ? "nav-item-active" : ""}`}
      >
        <Link to={item.path} onClick={hideMobileMenu}>
          {item.label}
        </Link>
      </div>
    ));
  };

  return (
    <AntHeader className="header-container">
      <div className="header-content">
        <Link to="/" className="logo-container">
          <img src={logoImage} alt="Logo" className="header-logo" />
        </Link>

        {screens.lg ? (
          <div className="desktop-nav">{renderNavigationItems()}</div>
        ) : (
          <>
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={showMobileMenu}
              className="mobile-menu-button"
            />
            <Drawer
              title="Navigation"
              placement="right"
              onClose={hideMobileMenu}
              open={mobileMenuVisible}
              className="mobile-drawer"
            >
              <div className="mobile-nav">{renderNavigationItems()}</div>
            </Drawer>
          </>
        )}
      </div>
    </AntHeader>
  );
};

export default Header;
